/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import './KanziSlideshow.css';

const fadeImages = [
    { src: "/KanziSlideshow/BabyKanzi.jpg", alt: "Young Kanzi" },
    { src: "/KanziSlideshow/GroupPhoto.jpg", alt: "Kanzi with researchers and caregivers" },
    { src: "/KanziSlideshow/KanziAndKeyboard2.jpg", alt: "Kanzi using a lexigram keyboard" },
    { src: "/KanziSlideshow/KanziAndSue.jpg", alt: "Kanzi with Sue Savage-Rumbaugh" },
    { src: "/KanziSlideshow/KanziFloorLexigrams.jpg", alt: "Kanzi near floor lexigrams" },
    { src: "/KanziSlideshow/KanziFrontsKeyboard.jpg", alt: "Kanzi in front of a lexigram keyboard" },
    { src: "/KanziSlideshow/KanziPointsToLexigram.jpg", alt: "Kanzi pointing to a lexigram" },
    { src: "/KanziSlideshow/KanziReachesForSue.jpg", alt: "Kanzi reaching toward Sue Savage-Rumbaugh" },
    { src: "/KanziSlideshow/KanziUnderUmbrella.jpg", alt: "Kanzi under an umbrella" },
    { src: "/KanziSlideshow/SleepyBoy.jpg", alt: "Kanzi resting" },
    { src: "/KanziSlideshow/WetKanzi.jpg", alt: "Kanzi wet from water play" },
  ];

const fadeProperties = {
    duration: 2500,             // How long each slide is shown (in ms)
    transitionDuration: 1000,   // Duration of the fade animation (in ms)
    infinite: true,
    arrows: true,
    pauseOnHover: false
  };

const KanziSlideshow = () => {
    return (
        <div className="KanziPhoto-slide-container">
          <Fade {...fadeProperties}>
            {fadeImages.map((image) => (
              <div className="each-fade" key={image.src}>
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </Fade>
        </div>
      );
}

export default KanziSlideshow;
